import { render, staticRenderFns } from "./AddressPicker.vue?vue&type=template&id=238471f0&scoped=true&"
import script from "./AddressPicker.vue?vue&type=script&lang=js&"
export * from "./AddressPicker.vue?vue&type=script&lang=js&"
import style0 from "./AddressPicker.vue?vue&type=style&index=0&id=238471f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238471f0",
  null
  
)

export default component.exports